import { gql, useQuery } from '@apollo/client';

export const COUNT_PROCESS_WIDGET_TASKS = gql`
  query countProcessWidgetTasks {
    countProcessWidgetTasks {
      open
      overdue
    }
  }
`;

export const useCountProcessWidgetTasks = () => {
  const { data, loading } = useQuery(COUNT_PROCESS_WIDGET_TASKS, {
    variables: {},
    fetchPolicy: 'no-cache',
  });

  const tasks = data?.countProcessWidgetTasks || {};

  return {
    loading,
    tasks,
  };
};
